export default __webpack_public_path__ + "media/images/onglettitre-small-9ddb8d311da51822ea6fb35c90795ec9.png";